import React, { useContext, useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Collapse from '@material-ui/core/Collapse';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListSubheader from '@material-ui/core/ListSubheader'
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import Checkbox from '@material-ui/core/Checkbox';
import IconButton from '@material-ui/core/IconButton';
import ArrowDownward from '@material-ui/icons/ExpandMore';
import ArrowUpward from '@material-ui/icons/ExpandLess';
import { MyContext } from './MyContext';


const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        maxWidth: 360,
        backgroundColor: theme.palette.background.paper,
    },
}));



export default function MachineListGrouped() {
    const { data, selectedMachines, setSelectedMachines, customerName } = useContext(MyContext)
    const classes = useStyles();
    // const [checked, setChecked] = React.useState([0]);
    const [selectAllChecked, setSelectAll] = useState(true);
    const [groupedData, setGroupedData] = useState()
    const [open, setOpen] = useState(true);
    const [groupOpen, setGroupOpen] = useState({})
    const [selectedGroups, setSelectedGroups] = useState([]);
    const [currCustomer, setCurrCustomer] = useState(customerName);

    

    //group the machine list by group, we're currently using the machinenamealias property for this
    useEffect(() => {
        //when the data.machines [] is updated we need to recreate the group
        
        if (data) {
            console.log("MachineListGrouped data.customer: " + data.customer + " currCustomer: " + currCustomer)
            console.log("MachineListGrouped useEffect data changed: data.customer: " + data?.customer + " recreating the groupings");
            const newSelectedGroups=[]
            const newGroupOpen={}
            const grpdData = data.machines.reduce((acc, obj) => {

                //unassigned is most likely to be at the end of the grouping list alphabetically
                const key = obj.machinenamealias ? obj.machinenamealias : "unassigned"; 
                //this makes sure every object has at least the not assigned machinenamealias
                obj.machinenamealias = key
                //not every obj has machinenamealias so it can be null
                if (key) {
                    if (!acc[key]) {
                        acc[key] = [];
                        newSelectedGroups.push(key)
                        newGroupOpen[key]=true
                    }
                    acc[key].push(obj);
                }
                return acc;
            }, {});
            //init all groups open
            setGroupOpen(newGroupOpen)
            //init new group data
            setGroupedData(grpdData)
            //we need to initialized to all the groups selected
            setSelectedGroups(newSelectedGroups)
        }


    }, []) //5/7/2024 I oringally had [data] but the selection would get reset after each time period change


    useEffect(() => {
        setSelectAll(data?.machines.length === selectedMachines.length)
    }, [selectedMachines])

    useEffect(() => {
        if (data?.machines) {
            const newChecked = [...selectedMachines];
            data.machines.map((machine) => {
                const currentGroupIndex = selectedGroups.indexOf(machine.machinenamealias);
                //add the machines to the selected list if this group is selected
                const currentMachineIndex = newChecked.indexOf(machine.machinename);
                if (currentGroupIndex !== -1) {
                    if (currentMachineIndex === -1) {
                        newChecked.push(machine.machinename);
                    }
                }
                else{
                    //remove the machines from the selected list if this group is not selected
                    if (currentMachineIndex !== -1) {
                        newChecked.splice(currentMachineIndex, 1);
                    }
                }
            })
            setSelectedMachines(newChecked);
        }

    }, [selectedGroups])

    const handleSelectAll = () => () => {
        console.log("MachineList handleSelectAll");
        if (data?.machines) {
            var newChecked = [];
            var newSelectedGroups=[]
            if (!selectAllChecked) {
                //set all machines selected

                if (data?.machines) {
                    data.machines.map((value) => {
                        newChecked.push(value.machinename);
                        //keep the groups in sync w/ the selectAll
                        if (!newSelectedGroups.includes(value.machinenamealias))
                        {
                            newSelectedGroups.push(value.machinenamealias)
                        }
                    });

                }
            }
            setSelectedMachines(newChecked);
            setSelectedGroups(newSelectedGroups)
            //set all selected to the opposite of the current value
            setSelectAll(!selectAllChecked);
        }
    };

    const handleGroupToggle = (groupName) => () => {
        console.log("MachineListGroup handleGroupToggle groupName: " + groupName);
        const currentIndex = selectedGroups.indexOf(groupName);
        const newChecked = [...selectedGroups];


        if (currentIndex === -1) {
            newChecked.push(groupName);
        } else {
            newChecked.splice(currentIndex, 1);
        }

        setSelectedGroups(newChecked);
    };
    const toggleMachineSelection = (value) => {
        const currentIndex = selectedMachines.indexOf(value);
        const newChecked = [...selectedMachines];

        if (currentIndex === -1) {
            newChecked.push(value);
        } else {
            newChecked.splice(currentIndex, 1);
        }

        setSelectedMachines(newChecked);
    }
    const handleToggle = (value) => () => {
        toggleMachineSelection(value)
    };
    const handleGroupCollapseClick = (groupName) => ()=> {

        console.log("MachineListGrouped handleCollapseClick: " + groupName)

        const newGroupOpen ={}
       for (var key in groupOpen){
        if (key==groupName)
        {
            newGroupOpen[key] = !groupOpen[key]
        }
        else{
            newGroupOpen[key] = groupOpen[key]
        }
       }
        setGroupOpen(newGroupOpen);
        setOpen(!open);
    };
    return (
        <List className={classes.root}>
            <ListItem key="selectall" dense button onClick={handleSelectAll()}>
                <ListItemIcon>
                    <Checkbox
                        edge="start"
                        checked={selectAllChecked}
                        tabIndex={-1}
                        disableRipple

                    />
                </ListItemIcon>
                <ListItemText id="checkbox-list-label-selectall" primary="Select All" />
            </ListItem>
            {/* Sort the keys alphabetically -- default sort */}
            {groupedData && Object.keys(groupedData).sort().map((machineNameAlias) => (
                <React.Fragment key={machineNameAlias}>
                    <ListItem >
                        <Checkbox
                        onClick={handleGroupToggle(machineNameAlias)}
                            edge="start"
                            checked={selectedGroups.indexOf(machineNameAlias) !== -1}
                            tabIndex={-1}
                            disableRipple
                        // inputProps={{ 'aria-labelledby': "checkbox-list-label-" + machine.machinename }}
                        />
                        <ListItem dense>{machineNameAlias}</ListItem>
                        <IconButton onClick={handleGroupCollapseClick(machineNameAlias)}>
                        {open ?<ArrowDownward fontSize='small'/>:<ArrowUpward fontSize='small'/>}

                        </IconButton>
                    </ListItem>
                    <Collapse in={groupOpen[machineNameAlias]} timeout="auto" unmountOnExit>
                    {groupedData[machineNameAlias].map((machine, index) => (

                        <ListItem key={machine.machinename} role={undefined} dense button onClick={handleToggle(machine.machinename)}>
                             
                            <ListItemIcon>
                                {/* this next ListItemText causes the checkbox to indent under the group name, it looks better */}
                            <ListItemText/>
                                <Checkbox
                                    edge="start"
                                    checked={selectedMachines.indexOf(machine.machinename) !== -1}
                                    tabIndex={-1}
                                    disableRipple
                                    inputProps={{ 'aria-labelledby': "checkbox-list-label-" + machine.machinename }}
                                >
                                    </Checkbox>
                                    
                                    
                            </ListItemIcon>
                            <ListItemText  primary={machine.machinename} />
                            

                        </ListItem>

                    ))}
                     </Collapse>
                </React.Fragment>
            ))}
        </List>
    );
}
